
import { OrganizationData, SortColumn, SortDirection } from "@/hooks/useOrganizationManagement";
import { Table, TableBody } from "@/components/ui/table";
import { OrganizationsTableHeader } from "./OrganizationsTableHeader";
import { OrganizationsTableRow } from "./OrganizationsTableRow";
import { OrganizationsTableStatus } from "./OrganizationsTableStatus";

interface OrganizationsTableProps {
  organizations: OrganizationData[];
  loading: boolean;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
  onEdit: (organization: OrganizationData) => void;
  onDelete: (organization: OrganizationData) => void;
}

export function OrganizationsTable({
  organizations,
  loading,
  sortColumn,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
}: OrganizationsTableProps) {
  const isEmpty = organizations.length === 0;

  return (
    <div className="bg-card rounded-lg overflow-hidden border border-border/40">
      <Table>
        <OrganizationsTableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableBody>
          <OrganizationsTableStatus loading={loading} isEmpty={isEmpty} />
          
          {!loading && !isEmpty && organizations.map((organization) => (
            <OrganizationsTableRow 
              key={organization.id}
              organization={organization} 
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
